/* eslint-disable no-eval */
import { isString } from 'lodash';
import queryString from 'query-string';
import { fromB64 } from './base64';
import COLORS from './constants/COLORS';
import { evaluate } from './eval';

export const scrollTop = () => {
  window.scrollTo({ top: 0 });
};

export const getColorByIndex = (index) => {
  switch (index) {
    case 0:
      return COLORS.cyan50;
    case 1:
      return COLORS.orange60;

    case 2:
      return COLORS.purple60;

    case 3:
      return COLORS.teal50;

    default:
      return COLORS.primary;
  }
};

export const procesarPrecio = (valor, simbolo) => {
  if (simbolo === '$') {
    return `$${valor}`;
  }
  return `$${valor} ${simbolo}`;
};

export const getColorByPlan = (plan) => {
  switch (plan) {
    case 'gold':
      return COLORS.gold;

    case 'amplia':
      return COLORS.amplia;

    case 'limitada':
      return COLORS.limitada;

    case 'basica':
      return COLORS.basica;

    default:
      return COLORS.primary;
  }
};

export const isArray = (instance) => instance instanceof Array;

export const mapArrayDropdownOptions = (instance) => ({
  label: instance.label,
  value: instance,
});

export const processRulesBD = (rules, resources) => {
  try {
    if (rules && typeof rules === 'object') {
      if (rules?.validate) {
        const { validate } = rules;
        if (typeof validate === 'object') {
          const entries = Object.entries(rules?.validate);
          if (entries.length > 0) {
            entries.forEach(([key, value]) => {
              let validation = () => true;

              if (isString(value)) {
                validation = evaluate(value);
              }
              rules.validate[key] = async (value) => await validation(value, resources);
            });
          }
        } else if (isString(validate)) {
          const validation = evaluate(rules.validate);

          rules.validate = async (value) => await validation(value, resources);
        }
      }

      if (typeof rules?.pattern?.value === 'string') {
        rules.pattern.value = new RegExp(rules.pattern.value);
      }

      return rules;
    }

    return rules || {};
  } catch (e) {
    console.error(e);
    return { ...rules, validate: null };
  }
};

export const mappRutasEmision = (rutas, queryParams = '') => {
  return Object.fromEntries(
    rutas.map((ruta) => {
      ruta.goBack = `${ruta.goBack}${queryParams}`;
      ruta.goTo = `${ruta.goTo}${queryParams}`;
      return [ruta.paso || ruta.codigo, ruta];
    })
  );
};

export const getQueryParams = () => {
  const qParams = queryString.parse(window.location.search);

  if (qParams?.query) {
    const query = fromB64(qParams?.query);
    return {
      ...qParams,
      ...query,
    };
  }
  return qParams;
};

export function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Creates a throttled version of a function that, when invoked repeatedly,
 * will only actually call the original function at most once every `limit` milliseconds.
 *
 * @param {Function} func - The function to throttle.
 * @param {number} limit - The number of milliseconds to throttle executions to.
 * @returns {Function} A new function that wraps the original function with throttling logic.
 */
export const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;

  return function (...args) {
    const context = this;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

export const obtenerStackTrace = () => {
  try {
    throw new Error('Obteniendo Stack Trace');
  } catch (error) {
    return error.stack;
  }
};
